import script from "./Invoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./Invoice.vue?vue&type=script&setup=true&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=f04a85d0&lang=css"

const __exports__ = script;

export default __exports__